import {RECEIVE_JOBS, REQUEST_JOBS} from "../actionTypes";
import {
  fetchJobs as networkFetchJobs
} from 'services';

function requestJobs() {
  return {
    type: REQUEST_JOBS,
  }
}

function receiveJobs(jobs) {
  return {
    type: RECEIVE_JOBS,
    items: jobs
  }
}

export function fetchJobs() {
  return dispatch => {
    dispatch(requestJobs());
    return networkFetchJobs().then(jobs => dispatch(receiveJobs(jobs)));
  }
}

export function fetchJobsIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.managers.items) {
      return dispatch(fetchJobs());
    }
  }
}


// WEBPACK FOOTER //
// ./src/state/actions/jobs.js